<div class="card card-grey card-form">
  <form *ngIf="(accountStatus$ | async)?.dietitian !== undefined; else loading" [formGroup]="form"  name="change-password-form" (ngSubmit)="submit()">
    <div id="old-password-form" class="form-field">
      <label>Ancien mot de passe</label>
      <input type="password" [class.is-invalid]="oldPasswordInvalid" autocomplete="on" class="form-control"
        id="old-password-input" formControlName="oldPassword">
      <div class="invalid-feedback">
        Veuillez entrer votre ancien mot de passe.
      </div>
    </div>
    <div id="password-form" class="form-field">
      <label>Nouveau mot de passe</label>
      <input type="password" [class.is-invalid]="passwordInvalid" autocomplete="on" class="form-control"
        id="password-input" formControlName="password">
      <div class="invalid-feedback">
        Le mot de passe doit comporter au minimum 6 caractères, 1 majuscule et 1 minuscule, 1 chiffre et aucun caractère spéciaux.
      </div>
    </div>
    <div id="password-confirmation-form" class="form-field">
      <label>Confirmation du nouveau mot de passe</label>
      <input type="password" autocomplete="on" [class.is-invalid]="passwordConfirmationInvalid" class="form-control"
        id="password-confirmation-input" formControlName="passwordConfirmation">
      <div class="invalid-feedback">
        Les mots de passe ne correspondent pas.
      </div>
    </div>
    <div *ngIf="(accountStatus$ | async)?.error as error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    <button id="submit-button" type="submit" [disabled]="!form.valid" class="btn btn-primary btn-gradient text-icon">
      Sauvegarder
      <i i-bs name="check-square" width="15" height="15"></i>
    </button>
  </form>
  <ng-template #loading>
    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
  </ng-template>
</div>
